import React from "react";
import { useHorizontalScroll } from "../../lib/hooks/useHorizontalScroll";
import RoadmapItem from "./RoadmapItem";
import { useLanguage } from "../../context/LanguageContext";

const Roadmap = () => {
  const { t } = useLanguage();
  const scrollRef = useHorizontalScroll();

  // Map the translation data to the expected structure for RoadmapItem
  const roadmap_items = t("roadmap.items").map((item) => ({
    roadmapTitle: item.year,
    title: item.title,
    info: item.points,
  }));

  return (
    <section id="market-growth" className="roadmap-area pt-130 pb-130">
      <div className="container custom-container-two">
        <div className="row justify-content-center">
          <div className="col-xl-5 col-lg-8">
            <div className="section-title text-center mb-60">
              <h2 className="title">{t("roadmap.title")}</h2>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12">
            <div
              className="bt-roadmap_x bt-roadmap-scrollbar"
              ref={scrollRef}
              style={{
                overflow: "auto",
                scrollbarWidth: "none" /* Firefox */,
                msOverflowStyle: "none" /* Internet Explorer 10+ */,
              }}
            >
              <div className="bt-roadmap-wrap">
                {roadmap_items.map((x, index) => (
                  <RoadmapItem key={index} item={x} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Roadmap;
